import { Loader as PulseLoader } from "@afterpaytouch/core";
import classNames from "classnames/bind";
import React from "react";

import Loader from "./loader";
import styles from "./loader-overlay.module.scss";

const cx = classNames.bind(styles);

interface LoaderOverlayProps {
    variant?: "default" | "pulse";
}

export const LoaderOverlay: React.FC<LoaderOverlayProps> = ({ variant = "default" }) => {
    const overlayClass = cx(styles.overlay, {
        [styles.overlayPulse]: variant === "pulse",
    });

    return (
        <>
            <div className={overlayClass}></div>
            <div className={styles.loaderContainer}>
                {variant === "default" && <Loader />}
                {variant === "pulse" && <PulseLoader />}
            </div>
        </>
    );
};
